import React, { useContext } from "react";
import { PagesContext } from "../../context/authContext";
import ContentWrapper from "./contentWrapper";
import ForecastsYearPage from "../pages/ForecastsYearPage/ForecastsYearPage";
import ForecastsDayPage from "../pages/ForecastDayPage/ForecastDayPage";
import ForecastsMonthPage from "../pages/ForecastMonthPage/ForecastMonthPage";
import ForecastsPage from "../pages/ForecastPage/ForecastPage";
import EventsPage from "../pages/EventsPage/EventsPage"

const Content = function(){
    const {page} = useContext(PagesContext);
    switch (page) {
        case "forecasts_year":
            return (
                <ContentWrapper pageId={page}>
                    <ForecastsYearPage/>
                </ContentWrapper>
            );    
        case "forecasts_month":
            return (
                <ContentWrapper pageId={page}>
                    <ForecastsMonthPage/>
                </ContentWrapper>
            );        
        case "forecasts_day":
            return (
                <ContentWrapper pageId={page}>
                    <ForecastsDayPage/>
                </ContentWrapper>
            );
        case "forecasts":
            return (
                <ContentWrapper pageId={page}>
                    <ForecastsPage />
                </ContentWrapper>
            );       
        case "events":
            return (
                <ContentWrapper pageId={page}>
                    <EventsPage/>
                </ContentWrapper>
            );  
        default:
            return (
                <ContentWrapper pageId={page}>
                    <h1>Switch page Default</h1>
                </ContentWrapper>
            );      
    }
}
export default Content;